// src/features/landing/presentation/components/BrandStorySection.jsx
import React from "react";

export function BrandStorySection() {
    return (
        <section id="brand-story" className="section section-light">
            <div className="container two-column">
                <div className="section-text">
                    <p className="section-kicker">Brand Story</p>
                    <h2 className="section-title">라이징브로커즈 소개</h2>
                    <p className="section-body">
                        보험업계는 오랜 시간 지인 소개, 높은 소개비, 검증되지 않은 인재풀이라는 구조적 한계에 갇혀 있었습니다.
                        Rising Brokers는 이러한 비효율을 혁신하기 위해 탄생했습니다.
                        15년 이상의 보험업계 전문 노하우를 바탕으로, 우리는 GA 매니저·총무·스태프 채용의 모든 단계를
                        체계화하고 데이터화하여 <b>보험사와 GA, 전문인력 모두가 성공하는 생태계</b>를 구축합니다.
                    </p>
                    <p className="section-body">
                        단순히 사람을 연결하는 것을 넘어, <b>신뢰할 수 있는 검증 시스템</b>과 <b>투명한 매칭 프로세스</b>로
                        보험업계 인재 채용의 새로운 기준을 만들어갑니다.
                        '중개'라는 단어가 가진 부정적 이미지를 벗어나, 모든 이해관계자에게 가치를 창출하는
                        <b>프리미엄 보험전문 헤드헌팅 플랫폼</b>으로 자리매김합니다.
                    </p>
                </div>
                <div className="section-image-single">
                    <div className="image-card">
                        <img className="img-landing" src="/images/landing_4.png" alt="라이징 브로커" />
                    </div>
                </div>
            </div>
        </section>
    );
}
